export const LOGO = "/pinwin-logo-a.png";

export const IMAGES = {
  football: "/img-football.jpg",
  tennis: "/img-tennis.jpg",
  poker: "/img-poker.jpg",
  runner: "/img-runner.jpg",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -10, duration: 1.3 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
